import { api } from "../utils/api";
import UserStore from "../utils/UserStore";

const getSubjects = async () => {
  const res = await api.get("/ClassDiaryV1/subjects");
  return res.data;
};

const getClassPlan = async (date, subjects) => {
  let idTurmaDisc;

  if (typeof subjects === "string") {
    idTurmaDisc = subjects;
  } else {
    idTurmaDisc = subjects[0].idTurmaDisc;
  }
  const res = await api.get("/ClassDiaryV1/class-plan", {
    params: {
      date,
      idTurmaDisc,
      externalData: UserStore.getUserExternalInfo()
    }
  });
  return res.data;
};

const sendClassPlanContent = async data => {
  const res = await api.post(
    "/ClassDiaryV1/class-plan/effective-content",
    data
  );

  return res.data;
};

export default {
  getSubjects,
  sendClassPlanContent,
  getClassPlan
};
